function ImageHelper() {
	const images = document.querySelectorAll( 'img' );

	if ( images ) {
		images.forEach( ( image ) => {
			image.addEventListener( 'error', () => {
				image.classList.add( 'img-err' );
			} );
		} );
	}
}

export default ImageHelper;
